import { render, staticRenderFns } from "./chats.page.vue?vue&type=template&id=05bca08f&scoped=true&"
import script from "./chats.page.vue?vue&type=script&lang=js&"
export * from "./chats.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05bca08f",
  null
  
)

export default component.exports